import { AmberHoc, AmberHocProps } from '../../../util';
import {
  InventoryCalculationParametersFragmentFragment as Result,
  UpdateInventoryCalculationParametersMutationVariables as Variables,
  withUpdateInventoryCalculationParameters as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

export type WithUpdateInventoryCalculationParametersHocChildProps = {
  updateInventoryCalculationParameters: (variables: Variables) => Promise<Result>;
};

export const withUpdateInventoryCalculationParametersHoc: AmberHoc<
  {},
  WithUpdateInventoryCalculationParametersHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<{}, WithUpdateInventoryCalculationParametersHocChildProps, typeof component>,
    WithUpdateInventoryCalculationParametersHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        updateInventoryCalculationParameters: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected error');
          }
          const result = await mutate({
            variables,
          });
          if (!result) {
            throw new Error('Unexpected response from server');
          }
          const { errors, data } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data) {
            throw new Error('Unexpected response from server');
          }
          return data.updateInventoryCalculationParameters;
        },
      };
    },
  })(component as any);
